/**
* @ngdoc directive
* @name Spinner
*
* @description
  Spinning around icon used to show that something is loading / in progress
*
* @example
  <spinner class="spinner mod-md"></spinner>
*/

app.directive('spinner', ["PATH", function (PATH) {
  return {
    restrict: 'EA',
    templateUrl: PATH.assets + 'img/spinner.svg',
  	replace: true
  };
}]);



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/spinner/spinnerDirective.js